export default __webpack_public_path__ + "static/media/omnes_light-webfont.7b23eaab.ttf";